import React, { FC, useEffect, useState } from "react";

import { TaskCreationSuccessModal } from "../../Components/TaskCreationSuccessModal/TaskCreationSuccessModal";
import {
  clearJustPublishedId,
  getJustPublishedId,
} from "../../utils/justPublished";

/** Store links for the success modal's "Get the app" CTA (RT-4321). */
const APP_STORE_URLS = {
  ios: "https://apps.apple.com/be/app/ring-twice/id1357150375?l=fr-FR",
  android: "https://play.google.com/store/apps/details?id=be.listminut.app",
};

const isIosDevice = () => /iPad|iPhone|iPod/.test(navigator.userAgent);

export interface ITaskCreationSuccessModalRootProps {
  serviceRequestId?: string;
}

/** Shown once (HUB-5584): the flag is consumed on arrival, so a refresh does not reopen it. */
export const TaskCreationSuccessModalRoot: FC<
  ITaskCreationSuccessModalRootProps
> = ({ serviceRequestId }) => {
  const [isOpen, setIsOpen] = useState(
    () => getJustPublishedId() === serviceRequestId
  );

  useEffect(() => {
    if (isOpen) clearJustPublishedId();
  }, [isOpen]);

  const handleGetTheApp = () => {
    window.open(
      isIosDevice() ? APP_STORE_URLS.ios : APP_STORE_URLS.android,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <TaskCreationSuccessModal
      isOpen={isOpen}
      onSeeMyRequest={() => setIsOpen(false)}
      onGetTheApp={handleGetTheApp}
    />
  );
};
